module.exports = __webpack_public_path__ + "079966adaa7835d6e59e10b1cf4c70ac.mp3";